import { render, staticRenderFns } from "./SuperPrivacyIntroductionPage.vue?vue&type=template&id=52a5f2b3&scoped=true"
import script from "./SuperPrivacyIntroductionPage.vue?vue&type=script&lang=js"
export * from "./SuperPrivacyIntroductionPage.vue?vue&type=script&lang=js"
import style0 from "./SuperPrivacyIntroductionPage.vue?vue&type=style&index=0&id=52a5f2b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5f2b3",
  null
  
)

export default component.exports